import React from "react";
import { useNavigate } from "react-router-dom";


export default function Referencesdetailsform() {

    const Navigate = useNavigate()

    return (
        <>

            {/* Rferences details form start */}

            <div>
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div>
                        <div className="createaccountpage_content_header">
                            References
                        </div>
                        <div className="createaccountpage_content_text">
                            Insert any contact person as your references
                        </div>
                    </div>
                    <div>
                        <div className="createaccountpage_content_circle_wrap">
                            <div className="createaccountpage_content_circle">
                                <div className="createaccountpage_content_mask createaccountpage_content_half">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="createaccountpage_content_mask createaccountpage_content_full">
                                    <div className="createaccountpage_content_fill">
                                    </div>
                                </div>
                                <div className="inside-circle">3 of 3</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#companyone" aria-expanded="true" aria-controls="companyone">
                        Company 1
                    </button>
                    <div id="companyone" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companyoneaddress" className="createaccountpage_content_form_label">Address</label>
                                <input type="text" placeholder="city name" className="createaccountpage_content_form_input" name="companyoneaddress" id="companyoneaddress" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companyonecountry" className="createaccountpage_content_form_label">Country</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" name="companyonecountry" id="companyonecountry" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companyonecontactperson" className="createaccountpage_content_form_label">Contact Person</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" name="companyonecontactperson" id="companyonecontactperson" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companyonephone" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" name="companyonephone" id="companyonephone" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companyoneemailaddress" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="companyoneemailaddress" id="companyoneemailaddress" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#companytwo" aria-expanded="true" aria-controls="companytwo">
                        Company 2
                    </button>
                    <div id="companytwo" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companytwoaddress" className="createaccountpage_content_form_label">Address</label>
                                <input type="text" placeholder="city name" className="createaccountpage_content_form_input" name="companytwoaddress" id="companytwoaddress" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companytwocountry" className="createaccountpage_content_form_label">Country</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" name="companytwocountry" id="companytwocountry" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companytwocontactperson" className="createaccountpage_content_form_label">Contact Person</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" name="companytwocontactperson" id="companytwocontactperson" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companytwophone" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" name="companytwophone" id="companytwophone" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companytwoemailaddress" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="companytwoemailaddress" id="companytwoemailaddress" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#companythree" aria-expanded="true" aria-controls="companythree">
                        Company 3
                    </button>
                    <div id="companythree" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <form>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companythreeaddress" className="createaccountpage_content_form_label">Address</label>
                                <input type="text" placeholder="city name" className="createaccountpage_content_form_input" name="companythreeaddress" id="companythreeaddress" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companythreecountry" className="createaccountpage_content_form_label">Country</label>
                                <input type="text" placeholder="e.g John Doe" className="createaccountpage_content_form_input" name="companythreecountry" id="companythreecountry" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companythreecontactperson" className="createaccountpage_content_form_label">Contact Person</label>
                                <input type="text" placeholder="insert your email address" className="createaccountpage_content_form_input" name="companythreecontactperson" id="companythreecontactperson" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companythreephone" className="createaccountpage_content_form_label">Phone</label>
                                <input type="text" placeholder="phone number start with your country code" className="createaccountpage_content_form_input" name="companythreephone" id="companythreephone" />
                            </div>

                            <div className="createaccountpage_content_form">
                                <label htmlFor="companythreeemailaddress" className="createaccountpage_content_form_label">Email Address</label>
                                <input type="text" placeholder="street, number, and building name" className="createaccountpage_content_form_input" name="companythreeemailaddress" id="companythreeemailaddress" />
                            </div>

                        </form>
                    </div>

                </div>

                <div className="createaccountpage_content_submit_review_button">
                    <button type="button" className="review_button" data-bs-toggle="modal" data-bs-target="#sumbitandreviewmodal">
                        Review & Submit
                    </button>

                    <div className="modal fade" id="sumbitandreviewmodal">
                        <div className="modal-dialog modal-dialog-centered submit_review_modal">
                            <div className="modal-content">

                                <div className="submit_review_modal_img">
                                    <img src="/assets/images/mandat-Outline.png" alt="" />
                                </div>

                                <div className="modal-header">
                                    <h3 className="modal-title">Submit My Registration</h3>
                                </div>

                                <div className="modal-body">
                                    We will check the validity of the data and give a final decision
                                    within 2x24 hours. Do you want to send the data now?
                                </div>

                                <div className="submit_review_modal_buttons">
                                    <button type="button" className="submit_review_modal_cancle_button" data-bs-dismiss="modal">Cancel</button>
                                    <button type="button" className="submit_review_modal_send_button" data-bs-dismiss="modal" onClick={() => {
                                        Navigate("/myaccountpage");
                                    }}>Send Now</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Rferences details form over */}
        </>
    )

}